// extracted by mini-css-extract-plugin
export default {"container":"CodeVerification_container__6qGv0","code":"CodeVerification_code__3WsMP","warning":"CodeVerification_warning__qLZNH"};